import { NotificationList } from 'components/common/NotificationList'
import { put, takeLatest } from 'redux-saga/effects'
import { makeGetRequest } from 'utils/api'
import { formatResponse, formatErrorMessage } from 'utils/formatting'
import { getTenant } from 'utils/authService'

import * as ACT from './actions'
import { PUSH_NOTIFICATION } from 'actions/actionTypes'

function* fetchLoggedInUser() {
  try {
    const url = '/v1/users/me'
    const loggedInUser = yield makeGetRequest(url)
    yield put({
      type: ACT.GET_LOGGED_IN_USER_FETCH_SUCCESS,
      payload: {
        loggedInUser
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue fetching Logged in User',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* fetchLogo() {
  try {
    const { logo, backgroundColor } = yield makeGetRequest('/v1/organization/get-logo', {
      headers: {
        'x-tenant-schema': getTenant()
      }
    })
    yield put({
      type: ACT.GET_LOGO_FETCH_SUCCESS,
      payload: {
        logo,
        backgroundColor
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue fetching Logo',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

const headerSagas = [
  takeLatest(ACT.GET_LOGGED_IN_USER_FETCH_REQUESTED, fetchLoggedInUser),
  takeLatest(ACT.GET_LOGO_FETCH_REQUESTED, fetchLogo)
]

export default headerSagas
